export default __webpack_public_path__ + "fonts/ArgoBold.TTF";